var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteIcon = function SvgQuoteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.732 23.254v-8.618c0-4.084.967-7.311 2.9-9.68C5.592 2.587 8.438 1.035 12.17.3v4.248c-2.778.87-4.643 2.368-5.596 4.492a7.284 7.284 0 0 0-.613 3.472h6.413v10.742H.733ZM31.528 4.547c-2.75.845-4.601 2.37-5.554 4.575-.545 1.17-.763 2.3-.654 3.39h6.412v10.742h-11.64v-8.618c0-4.139.994-7.38 2.982-9.72C25.089 2.572 27.907 1.034 31.528.3v4.248Z",
    fill: "#479DA6"
  })));
};
export default SvgQuoteIcon;